import {CountUp} from 'countup.js';

class AnimatePrice {
    /** @type {HTMLElement} */
    target;

    /**
     * Constructor
     * @param {String} changeElem
     * @param {String} targetId
     * @param {String} separator
     */
    constructor({
        changeElem = '',
        targetId = '',
        separator = ' ',
    }) {
        this.changeElem = changeElem;
        this.targetId = targetId;
        this.separator = separator;
        this.render();
    }

    /**
     * Static run
     * @param {Object} data
     * @return {AnimatePrice}
     */
    static run(data) {
        return new AnimatePrice(data);
    }

    /**
     * @param {HTMLElement} target
     * @return {number|boolean|boolean}
     */
    static getStartVal(target) {
        const item = Number(target.dataset.price);

        return item ?? false;
    }

    /**
     * @param {HTMLElement} target
     * @param {Number} item
     */
    static setStartVal(target, item) {
        target.dataset.price = String(item);
    }

    /**
     * Action on change input
     * @param {InputEvent} e
     */
    startAction = (e) => {
        const elem = e.target;

        if (elem.tagName.toLowerCase() !== 'input') {
            return;
        }

        const itemPrice = Number(elem.dataset.price);

        if (!itemPrice) {
            return;
        }

        const startVal = AnimatePrice.getStartVal(this.target);

        if (!startVal) {
            return;
        }

        const endVal = elem.checked ? startVal + itemPrice : startVal - itemPrice;
        const countUp = new CountUp(this.targetId, endVal, {
            startVal,
            duration: 1,
            separator: this.separator,
        });

        if (countUp.error) {
            throw new Error(countUp.error);
        }

        AnimatePrice.setStartVal(this.target, endVal);
        countUp.start();
    };

    /**
     * Listeners
     */
    setUpListeners() {
        let elements = document.querySelectorAll(this.changeElem);

        for (let elem of elements) {
            elem.addEventListener('change', this.startAction);
        }
    }

    render() {
        this.target = document.getElementById(this.targetId);

        if (!this.target) {
            return;
        }

        this.setUpListeners();
    }
}

export default AnimatePrice;
